<template>
  <div id="profile_container">
    <img id="profile_img" src="../assets/avatar.png" alt="" />
    <h2>Rin Yixi</h2>
    <div id="profile_description">
      <p class="profile_text">
        Birth {{ Birthdate.year }}/{{ Birthdate.month }}/{{ Birthdate.day }} Age
        {{ Age }}
      </p>
      <p class="profile_text">{{ Position }}</p>
      <div id="profile_intro" class="profile_text">
        <p>Welcome! This is a Rin Yixi's HomePage.</p>
        <p>If you wanna more know me, please access my SNS from under icon.</p>
      </div>
    </div>
    <div id="socials">
      <a href="https://twitter.com/Y1x1R1n" class="social_icon">
        <img src="../assets/twitter.svg" />
      </a>
      <a href="https://github.com/R1nY1x1" class="social_icon">
        <img src="../assets/github-icon.svg" />
      </a>
    </div>
    <ul id="pages">
      <li><router-link to="/">Profile</router-link></li>
      <li><router-link to="/gallery">Gallery</router-link></li>
      <li><router-link to="/skills">Skills</router-link></li>
      <li><router-link to="/blogs">Blogs</router-link></li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Age: 22,
      Birthdate: {
        day: 15,
        month: 1,
        year: 2000,
      },
    };
  },
  createed() {
    this.InitAge();
  },
  methods: {
    InitAge() {
      let birthdate = new Date(
        this.Birthdate.year,
        this.Birthdate.month - 1,
        this.Birthdate.day
      );
      let today = new Date();
      let age = today.getFullYear() - birthdate.getFullYear();
      if (
        today.getMonth() < birthdate.getMonth() ||
        (today.getMonth() === birthdate.getMonth() &&
          today.getDate() < birthdate.getDate())
      ) {
        age--;
      }
      this.Age = age;
    },
  },
};
</script>

<style lang="scss" scoped>
#profile_container {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: "メイリオ", sans-serif;
  #profile_img {
    width: 300px;
    height: 300px;
    border-radius: 100px;
    margin: 15px;
  }
  @media screen and (max-width: 400px) {
    #profile_img {
      width: 200px;
      height: 200px;
      border-radius: 75px;
    }
  }
  #profile_description {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .profile_text {
      padding: 10px;
      font-size: 19px;
    }
    @media screen and (max-width: 400px) {
      .profile_text {
        padding: 10px 25px;
      }
    }
  }
  #socials {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .social_icon {
      width: 100px;
      height: 100px;
      border-radius: 100px;
      margin: 10px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 100px;
        transition: 0.3s;
        &:hover {
          box-shadow: 0px 2px 10px -2px #777777;
        }
      }
    }
  }
  #pages {
    list-style: none;
    overflow: hidden;
    li {
      width: 140px;
      height: 20px;
      text-align: center;
      background-color: #333;
      float: left;
      line-height: 20px;
      margin-right: 2px;
      a {
        text-decoration: none;
        color: #fff;
        font-weight: bold;
        padding: 20px;
      }
    }
  }
}
</style>
